import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../lib/api';
export default function Sessions() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    async function load() {
        setLoading(true);
        setErr('');
        try {
            const r = await api('/auth/sessions');
            setRows(r);
        }
        catch (e) {
            setErr(String(e.message || e));
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => { load(); }, []);
    async function revoke(sid) {
        if (!confirm('撤銷此 session？該裝置將立刻被登出。'))
            return;
        try {
            await api(`/auth/sessions/${sid}/revoke`, { method: 'POST' });
            load();
        }
        catch (e) {
            alert(String(e.message || e));
        }
    }
    return (_jsxs("div", { children: [_jsx("h2", { children: "\u6211\u7684 Session" }), _jsx("p", { className: "muted", children: "\u6BCF\u6B21\u767B\u5165\u6703\u5EFA\u7ACB\u4E00\u500B session\u3002\u64A4\u92B7\u5F8C\u8A72\u88DD\u7F6E\u7684 access/refresh token \u7ACB\u5373\u5931\u6548\u3002" }), err && _jsx("div", { className: "card", style: { color: '#f87171' }, children: err }), loading ? _jsx("div", { children: "\u8F09\u5165\u4E2D\u2026" }) : (_jsx("div", { className: "card", children: _jsxs("table", { className: "data-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\u5EFA\u7ACB" }), _jsx("th", { children: "\u6700\u5F8C\u6D3B\u52D5" }), _jsx("th", { children: "IP" }), _jsx("th", { children: "\u88DD\u7F6E" }), _jsx("th", { children: "\u5230\u671F" }), _jsx("th", { children: "\u72C0\u614B" }), _jsx("th", {})] }) }), _jsxs("tbody", { children: [rows.map(s => (_jsxs("tr", { children: [_jsx("td", { children: new Date(s.created_at).toLocaleString() }), _jsx("td", { children: s.last_seen_at ? new Date(s.last_seen_at).toLocaleString() : '—' }), _jsx("td", { children: s.ip || '—' }), _jsx("td", { style: { maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, title: s.user_agent || '', children: s.user_agent || '—' }), _jsx("td", { children: s.expires_at ? new Date(s.expires_at).toLocaleDateString() : '—' }), _jsx("td", { children: s.revoked_at
                                                ? _jsx("span", { className: "pill score-red", children: "\u5DF2\u64A4\u92B7" })
                                                : s.is_current
                                                    ? _jsx("span", { className: "pill score-green", children: "\u672C\u6A5F" })
                                                    : _jsx("span", { className: "pill score-yellow", children: "\u6D3B\u52D5\u4E2D" }) }), _jsx("td", { children: !s.revoked_at && !s.is_current && (_jsx("button", { onClick: () => revoke(s.id), children: "\u64A4\u92B7" })) })] }, s.id))), rows.length === 0 && _jsx("tr", { children: _jsx("td", { colSpan: 7, className: "muted", children: "\u7121\u8CC7\u6599" }) })] })] }) }))] }));
}
